namespace appn.views.brandCenter.siteIntegrations {

    class InitArgs {
        addSendGridDomainLink: string = emptyString;
        deleteSendGridDomainAuth: string = emptyString;
        showDnsRecordDialogLink: string = emptyString;
        removeBimi: string = emptyString;
    }

    let _initArgs: InitArgs;
    let _restHeaderTemplate = appn.emptyString;
    let _initialSendGridRegion: string = emptyString;

    export function init(args: InitArgs): void {
        _initArgs = args;

        // Store initial SendGrid region value
        _initialSendGridRegion = $('#Brand_WaaSDetails_SendGridRegion').val() as string;

        addEvents();

        registerFormExpansionHelper();

        // Grab the rest header template and remove it from the document.
        const restHeaderTemplate = $('#RESTHeaderRowTemplate');
        _restHeaderTemplate = restHeaderTemplate.html();
        restHeaderTemplate.remove();
        appn.ui.formExpansionHelper.init('.connector');

        $('.formatType').change(function() {
            const $this = $(this);
            const $connector = $this.closest('.connector');
            const format = $(this).val();

            if (format === 'RawJson' || format === 'RawXml' || format === 'UrlEncoded') {
                $connector.find('[data-expansion*="dataTemplate_"], [data-expansion-link*="dataTemplate_"]').addClass('d-none');
                $connector.find('.attachment-name').addClass('d-none');

                if (format === 'UrlEncoded') {
                    $connector.find('.restEntryFormat').addClass('d-none');
                    $connector.find('[data-expansion-link*="addFormData_CustomREST"]').removeClass('d-none');
                    $connector.find('.btn-tool[data-expansion-link*="addFormData_CustomREST"]').click();
                    $connector.find('[data-expansion-link*="customBody_CustomREST"]').addClass('d-none');
                    $connector.find('[data-expansion*="customBody_CustomREST"]').addClass('d-none');
                } else {
                    $connector.find('.restEntryFormat').removeClass('d-none');
                    $connector.find('[data-expansion-link*="addFormData_CustomREST"]').addClass('d-none');
                    $connector.find('[data-expansion*="addFormData_CustomREST"]').addClass('d-none');
                    $connector.find('[data-expansion-link*="customBody_CustomREST"]').removeClass('d-none');
                }
            } else {
                $connector.find('[data-expansion-link*="customBody_CustomREST"]').addClass('d-none');
                $connector.find('[data-expansion*="customBody_CustomREST"]').addClass('d-none');

                $connector.find('.restEntryFormat').addClass('d-none');
            }
        });

        $('.httpVerb').change(function() {
            const $this = $(this);
            const $connector = $this.closest('.connector');
            const $formatType = $connector.find('.formatType');
            const verb = $(this).val();

            if (verb !== 'Post' && verb !== 'Put' && verb !== 'Patch') {
                $formatType.find('option').not('[value="RawJson"]').not('[value="RawXml"]').addClass('d-none');
                if ($formatType.val() !== 'RawJson' && $formatType.val() !== 'RawXml') {
                    $formatType.val('RawJson');
                    $formatType.change();
                }
            } else
                $formatType.find('option').removeClass('d-none');

        });
    }

    function addEvents() {
        $('.addSendGridDomainItem').on('click', function(event) {
            event.preventDefault();
            appn.views.provider.integrations.addSendGridDomain(_initArgs.addSendGridDomainLink);
        });

        $(document).on('click', '.delete_button_sendGridDomainAuth', function(event) {
            event.preventDefault();

            // Get all the details before deleting the row
            let row = $(this).closest('tr');
            let table = $(this).closest('table');
            let domainName = row.find('[id$="DomainName"]').val() as string;
            let domainId = row.find('[id$="DomainId"]').val() as string;

            if (!utils.hasValue(domainId)) {
                row.remove();
                renameRows();

                if (table.find('tbody tr').length === 0)
                    table.hideElement();

                // Display the add item button
                $('.addSendGridDomainItem').showElement();

                return;
            }

            appn.dialog.custom({
                modalColor: 'modal-danger',
                title: T(`Delete Domain {0}?`, domainName),
                message: T(`You are about to permanently delete the domain named {0}. <br><br>Hit the <b>Delete</b> button to proceed.`, domainName),
                isDeleteAction: true,
                closeButton: true,
                buttons: {
                    trash: {
                        label: '<span>' + T('Delete') + '</span>',
                        className: 'btn-danger',
                        callback: function(result: any) {
                            if (result) {
                                appn.ajax.post({
                                    url: _initArgs.deleteSendGridDomainAuth,
                                    dataType: 'json',
                                    data: {
                                        domainId: domainId
                                    },
                                    done: function() {
                                        row.remove();
                                        renameRows();

                                        if (table.find('tbody tr').length === 0)
                                            table.hideElement();

                                        // Reload to ensure we don't get a stale data error
                                        appn.location.reloadCurrentPage();
                                    },
                                    fail: function() {
                                        appn.toast.notify(toast.Type.error, T('Failed to delete domain.'));
                                    }
                                });
                            }
                        }
                    }
                }
            });
        });

        $(document).on('click', '.btn-showVerifyDialog', function(event) {
            event.preventDefault();

            let domainId = $(this).closest('tr').find('[id$="DomainId"]').val() as string;
            appn.views.provider.integrations.showVerifySendGridDomain(_initArgs.showDnsRecordDialogLink, domainId);
        });

        $(document).on('click', '.btn-remove', function() {
            let button = $(this);
            let row = button.closest('tr');
            let domainId = row.find('[id$="DomainId"]').val() as string;

            appn.ajax.post({
                url: _initArgs.removeBimi,
                dataType: 'json',
                data: {
                    domainId: domainId,
                },
                done: function() {
                    button.hideElement();

                    // Reload to ensure we don't get a stale data error
                    appn.location.reloadCurrentPage();
                },
                fail: function() {
                    appn.toast.notify(toast.Type.error, T('Failed to delete BIMI image'));
                }
            });
        });

        // SendGrid Region change warning
        $('#Brand_WaaSDetails_SendGridRegion').on('change', function() {
            const $dropdown = $(this);
            const newRegion = $dropdown.val() as string;

            // Show warning if region changed
            if (newRegion !== _initialSendGridRegion) {
                const regionLabel = newRegion === 'EU' ? 'EU' : 'US';
                appn.dialog.confirm({
                    modalColor: 'modal-warning',
                    title: T('Switching SendGrid API Regions?'),
                    message: T('Make sure to generate and paste a new API key from your SendGrid {0} subuser dashboard, or your emails will fail to send.', regionLabel),
                    buttons: {
                        confirm: {
                            label: '<span>' + T('Switch Region') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function(result: any) {
                        if (result) {
                            _initialSendGridRegion = newRegion;
                            // Trigger save
                            const form = $('form#appnForm');
                            form.append('<input type="hidden" name="submitType" value="Save" />');
                            form.submit();
                        }
                        else {
                            $dropdown.val(_initialSendGridRegion).trigger('change');
                        }
                    }
                });
            }
        });

        // Show/hide region dropdown based on API key presence
        $('input[id$="Brand_WaaSDetails_SendGridApiKey"]').on('input change', function() {
            const hasApiKey = ($(this).val() as string).trim().length > 0;
            const $regionWrapper = $('#SendGridRegionWrapper');

            if (hasApiKey) {
                $regionWrapper.show();
            } else {
                $regionWrapper.hide();
                $('#Brand_WaaSDetails_SendGridRegion').val(_initialSendGridRegion).trigger('change');
            }
        });
    }

    function renameRows() {
        // Rename remaining rows to keep continuous index
        $(`#sendGridDomainAuthTable tbody tr`).each(function(index) {
            $(this).find('[id$="DomainId"]')
                .attr({
                    name: `Brand.WaaSDetails.SendGridDomainAuth[${index}].DomainId`,
                    id: `Brand_WaaSDetails_SendGridDomainAuth_${index}__DomainId`
                });
            $(this).find('[id$="DomainName"]')
                .attr({
                    name: `Brand.WaaSDetails.SendGridDomainAuth[${index}].DomainName`,
                    id: `Brand_WaaSDetails_SendGridDomainAuth_${index}__DomainName`
                });
            $(this).find('.domainName')
                .attr({
                    name: `Brand.WaaSDetails.SendGridDomainAuth[${index}].DomainName`,
                    id: `Brand_WaaSDetails_SendGridDomainAuth_${index}__DomainName`
                });
            $(this).find('[id$="Username"]')
                .attr({
                    name: `Brand.WaaSDetails.SendGridDomainAuth[${index}].Username`,
                    id: `Brand_WaaSDetails_SendGridDomainAuth_${index}__Username`
                });
            $(this).find('.username')
                .attr({
                    name: `Brand.WaaSDetails.SendGridDomainAuth[${index}].Username`,
                    id: `Brand_WaaSDetails_SendGridDomainAuth_${index}__Username`
                });
            $(this).find('[id$="CustomDkimSelector"]')
                .attr({
                    name: `Brand.WaaSDetails.SendGridDomainAuth[${index}].CustomDkimSelector`,
                    id: `Brand_WaaSDetails_SendGridDomainAuth_${index}__CustomDkimSelector`
                });
            $(this).find('[id$="BimiImage"]')
                .attr({
                    name: `Brand.WaaSDetails.SendGridDomainAuth[${index}].BimiImage`,
                    id: `Brand_WaaSDetails_SendGridDomainAuth_${index}__BimiImage`
                });
        });
    }

    function registerFormExpansionHelper() {
        appn.ui.formExpansionHelper.registerHandler('customRestHeaders', function(common: any, show: any, hide: any) {
            return {
                open: function(key: any, $link: any, $expansion: any) {
                    common.open(key, $link, $expansion);
                    if ($expansion.find('.rest-header').length === 0)
                        $expansion.find('.add-header a').click();
                },
                insert: function(key: any, $link: any, $expansion: any) {
                    const connectorIdx = $expansion.closest('.connector').data('connector-index');
                    const newRowIdx = (new Date()).getTime();
                    const templateHtml = _restHeaderTemplate
                        .replace(/CustomRESTConnectors\[0\]/g, 'CustomRESTConnectors[' + connectorIdx + ']')
                        .replace(/CustomRESTConnectors_0__/g, 'CustomRESTConnectors_' + connectorIdx + '__')
                        .replace(/Headers\[0\]/g, 'Headers[' + newRowIdx + ']')
                        .replace(/Headers_0__/g, 'Headers_' + newRowIdx + '__')
                        .replace(/CustomRESTConnectors\[0\]/g, 'CustomRESTConnectors[' + connectorIdx + ']');

                    const $newRow = $(templateHtml);
                    $newRow.find('input').val('');
                    $newRow.find('.rowIndexer').val(newRowIdx);
                    $newRow.insertBefore($link.parent());
                },
                close: function(key: any, $link: any, $expansion: any) {
                    $link.closest('.rest-header').remove();
                    const $headerRows = $expansion.find('.rest-header');
                    if ($headerRows.length === 0)
                        common.close(key, $link, $expansion);
                }
            };
        });
    }

}
